import React from 'react';
import Header from './../../../component/common/AdminHeader';
import AddUser from './../../../component/user/Add';
import Loader from './../../../component/common/Loader';
import { ToastContainer ,toast } from 'react-toastify';
import CONSTANT from './../../../constant';
import { updateUser, getUserDetail } from './../../../actions/UserAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.match.params.code,
            detail: undefined,
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
        const { code } = this.state;

        this.setState({ showLoader: true });
        getUserDetail(code).then((res: any) => {
            this.setState({
                detail: res.result,
                showLoader: false
            });
        });
    }

    render() {
        const { code, detail, showLoader } = this.state;
        return (
            <div className="container-fluid">
                  <ToastContainer
                                position="top-right"
                                autoClose={1000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                />
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">User detail</h1>
                            </div>
                        </div>
                         
                           {
                            detail === undefined && <div>Loading...</div>
                            }
                         
                         {
                            detail !== undefined && <AddUser
                                detail={detail}
                                code={code}
                                onSubmit={this.onSubmit}
                            />
                        }
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onSubmit = (model: any) => {
        this.setState({ showLoader: true });
        updateUser(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res.status === CONSTANT.static.apiStatus.success) {
                 
                    toast.success('Changes were saved successfully', {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        }); 
                         
                     setTimeout(()=>{
                    this.props.history.push(CONSTANT.component.adminUserList.url);
                     },2000)
                  
            } else {
                toast.error  ( `${res.error} ` , {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });
            }
        });
    }
}

export default ComponentName;